import { ListingsTranslation } from 'locales/de/pages/listings';

const en: ListingsTranslation = {
  type: {
    flat: 'Flat rent',
    study: 'Study material',
    belongings: 'General'
  },
  steps: {
    category: 'Category',
    offer: 'Offer',
    personalContacts: 'Contact information',
    review: 'Review & Publish'
  },
  create: {
    title: 'New listing',
    category: {
      selectCategory: 'Select category',
      studyDescription: 'Study materials like books or tools',
      flatDescription:
        'Post here if you have a room or a flat to offer, or if you are looking for one',
      belongingsDescription: "Everything that doesn't fit in any other category has its place here"
    },
    offer: {
      offerText: 'Offer description',
      address: 'Pick-up address',
      photos: 'Photos',
      photosPlaceholder: 'Upload photos (jpeg, png)',
      lifetime: 'Offer Lifetime',
      lifetimeDescription: 'Please specify how long this offer will stand',
      startDate: 'Start date',
      endDate: 'End date',
      minCharsHelper: 'Please describe your offer in at least 150 characters'
    },
    personalContacts: {
      yourEmail: 'Your e-mail address',
      yourPhoneNumber: 'Your phone number'
    }
  },
  alerts: {
    saveSuccessful: 'The offer has been saved successfully',
    saveFailed: 'The offer could not be saved'
  },
  noListings: 'There are no listings on the bulletin board at this time',
  notFound: 'Could not find listing',
  openFailed: 'Listing could not be opened',
  ownListings: 'Own listings'
};

export default en;
